// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ErrorPage_pageWrapper__I3xzX","heading":"ErrorPage_heading__1cENY"};